var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useState } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { DefaultTheme } from '../../Themes';
import Label from '../Label';
import { Icon, IconLookup } from '../Icon';
const StyledContainer = styled.div `
  display: inline-flex;
  align-items: center;
`;
const StyledInputWrapper = styled.div `
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  overflow: hidden;

  ${({ hasLabel }) => hasLabel && css `
    margin-right: 0.916666667rem;
  `};
`;
const inputWrapperChildStyles = css `
  position: absolute;
  width: 100%;
  height: 100%;
`;
const StyledInputMask = styled.span `
  ${inputWrapperChildStyles};
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${({ color, theme }) => color || theme.ThemeColors.DARK_BORDER.hex};
  border-radius: 2px;
  box-sizing: border-box;
  z-index: 0;

  ${({ isDisabled }) => isDisabled && css `
    opacity: 0.5;
  `};
`;
const StyledInputCheckbox = styled.input `
  ${inputWrapperChildStyles};
  margin: 0;
  opacity: 0;
  z-index: 1;
  cursor: ${({ disabled }) => disabled ? 'disabled' : 'pointer'};

  &:checked + ${StyledInputMask} {
    ${({ color, theme }) => css `
      border-color: ${color || theme.ThemeColors.PRIMARY.hex};
      background-color: ${color || theme.ThemeColors.PRIMARY.hex};
    `};
  }
`;
const StyledCheckmarkIcon = styled(Icon) `
  color: ${({ theme }) => theme.ThemeColors.WHITE.hex};
  font-weight: 700;
`;
const Checkbox = (_a) => {
    var { className, labelClassName, id, isChecked = false, isDisabled, label, name, onChange = () => { }, value, color, colorWhenChecked, theme = DefaultTheme } = _a, rest = __rest(_a, ["className", "labelClassName", "id", "isChecked", "isDisabled", "label", "name", "onChange", "value", "color", "colorWhenChecked", "theme"]);
    const [checkedStatus, setCheckedStatus] = useState(isChecked);
    useEffect(() => {
        setCheckedStatus(isChecked);
    }, [isChecked]);
    const updateCheckedStatus = useCallback((event) => {
        if (!isDisabled) {
            const updatedCheckedStatus = event.target.checked || !checkedStatus;
            setCheckedStatus(updatedCheckedStatus);
            onChange(updatedCheckedStatus, value);
        }
    }, [checkedStatus, isDisabled, onChange, value]);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledContainer, Object.assign({ className: className }, rest),
            React.createElement(StyledInputWrapper, { hasLabel: !!label },
                React.createElement(StyledInputCheckbox, { type: 'checkbox', checked: checkedStatus, color: colorWhenChecked || color, disabled: isDisabled, id: id, name: name, onChange: updateCheckedStatus, value: value }),
                React.createElement(StyledInputMask, { color: color, isDisabled: isDisabled }, checkedStatus && React.createElement(StyledCheckmarkIcon, { icon: IconLookup.CHECK }))),
            label && (React.createElement(Label, { className: labelClassName, onClick: updateCheckedStatus, text: label })))));
};
export default Checkbox;
